import { InitializeAirwallexSdkUseCase } from './InitializeAirwallexSdkUseCase'

export const initializeAirwallexSdkUseCase = new InitializeAirwallexSdkUseCase(
  {}
).execute
